// src/components/SuccessStories.js
import React from 'react';
import { Box, Container, Grid, Typography, Card, CardMedia, CardContent } from '@mui/material';

const successItems = [
  {
    id: 1,
    title: "AMD Retail (Iberia)",
    description: "We grew AMD's market share from under 20% to 54%, marking the first time AMD outperformed Intel.",
    image: "/amd.png"
  },
  {
    id: 2,
    title: "Kioxia Europe",
    description: "We achieved brand penetration in key accounts across Germany, France, and Iberia, securing notable market share and, more importantly, brand recognition.",
    image: "/kioxia.png"
  },
  {
    id: 3,
    title: "Be Quiet! Iberia",
    description: "Starting with almost no presence to $1M in revenue within almost 1 year. We positioned the brand among major resellers, achieving remarkable growth.",
    image: "/bequiet.png"
  },
  {
    id: 4,
    title: "ADATA Iberia",
    description: "Starting from scratch, the brand was introduced and developed into most key reseller chains, including: Media Markt Iberia, Worten Iberia, El Corte Inglés, Eroski, Carrefour, Leclerc.",
    image: "/Adata.png"
  }
];

const SuccessStories = () => {
  return (
    <Box
      sx={{
        backgroundImage: `linear-gradient(rgba(3,116,206, 0.6), rgba(3,116,206, 0.6)), url(${process.env.PUBLIC_URL}/success.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        py: { xs: 4, md: 8 },
        minHeight: { xs: 'auto', md: '75vh' }
      }}
    >
      <Container maxWidth="lg">
        {/* Título principal */}
        <Typography 
          variant="h3" 
          align="center" 
          gutterBottom 
          color="white" 
          sx={{ 
            fontWeight: 'bold', 
            fontSize: { xs: '2rem', md: '3rem' }
          }}
        >
          Success Stories
        </Typography>
        {/* Listado de ítems: en móvil 1 por fila (xs=12) y en md 2 por fila (md=6) */}
        <Grid container spacing={4}>
          {successItems.map((item) => (
            <Grid key={item.id} item xs={12} md={6}>
              <Card 
                sx={{ 
                  backgroundColor: 'rgba(255, 255, 255, 0.8)', 
                  borderRadius: 2, 
                  boxShadow: 3, 
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'center',
                  height: { xs: 'auto', md: '25rem' },
                  p: { xs: 2, md: 0 }
                }}
              >
                {/* Imagen del ítem */}
                <CardMedia
                  component="img"
                  image={`${process.env.PUBLIC_URL}${item.image}`}
                  alt={item.title}
                  sx={{
                    width: { xs: '100%', md: '12rem' },
                    height: { xs: 'auto', md: '12rem' },
                    objectFit: 'cover'
                  }}
                />
                <CardContent>
                  {/* Título del ítem */}
                  <Typography 
                    variant="h5" 
                    gutterBottom 
                    sx={{ textAlign: 'center', fontWeight: 'bold', marginTop: '-2rem' }}
                  >
                    {item.title}
                  </Typography>
                  {/* Breve descripción */}
                  <Typography 
                    variant="h6" 
                    color="text.secondary" 
                    sx={{ textAlign: 'center' }}
                  >
                    {item.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default SuccessStories;
